import React from 'react';
import { useIntl } from 'react-intl';

const TagInfo = (props) => {
    const { row } = props
    const { messages } = useIntl();

    return (
        <div style={{ minHeight: 45, width: 249 }}>
            <div>
                <div style={{ display: 'flex', alignItems: 'flex-start', minHeight: 25 }}>
                    <strong style={{ marginRight: 5 }}>{messages['driver_performance_tagId']}:</strong><p style={{ wordBreak: 'break-word', overflowWrap: 'break-word', margin: 0, flex: 1, minWidth: 0 }}>{row?.tagId || 'N/A'}</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', minHeight: 20 }}>
                    <strong style={{ marginRight: 5 }}>{messages['driver_performance_tagName']}:</strong><p style={{ wordBreak: 'break-word', overflowWrap: 'break-word', margin: 0, flex: 1, minWidth: 0 }}>{row?.tagName || 'N/A'}</p>
                </div>
            </div>
        </div>
    )
}

export default TagInfo; 